document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                this.pagination.el.style.setProperty("--progress", 1 - progress);
            }
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;
    });

    let quadSlider = new Swiper('.slider__slider',{
        speed: 2000,
        loop: true,
        effect: 'fade',
        uniqueNavElements: false,
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next',
        },
        pagination: {
            el: '.slider-pagination',
            clickable: true
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                this.pagination.el.style.setProperty("--progress", 1 - progress);
            }
        },
        breakpoints: {
            650: {
                uniqueNavElements: true
            }
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next',
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let sliderLeft = new Swiper('.gallery-quad__slider-left',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let sliderCenter = new Swiper('.gallery-quad__slider-center',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-arrow-prev',
            nextEl: '.gallery-arrow-next'
        }
    });

    let sliderRight = new Swiper('.gallery-quad__slider-right',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: true,
        navigation: {
            prevEl: '.gallery-m-arrow-prev',
            nextEl: '.gallery-m-arrow-next'
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        breakpoints: {
            650: {
                allowTouchMove: false,
                navigation: false
            }
        }
    });

    sliderCenter.controller.control = [sliderLeft,sliderRight];

    if(document.querySelector('.all-rooms__slider')){
        document.querySelectorAll('.all-rooms__slider').forEach((element, i) => {
            let entryId = element.getAttribute('data-entry');
            element.setAttribute(`data-room-swiper-${i}`, "");
            let swiperRoom = new Swiper(`[data-room-swiper-${i}]`,{
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: `.room-${entryId}-prev`,
                    nextEl: `.room-${entryId}-next`
                }
            });
        });
    }

    let galleryRooms = new Swiper('.gallery-rooms__slider',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: '.gallery-rooms-prev',
            nextEl: '.gallery-rooms-next'
        },
        breakpoints: {
            650: {
                slidesPerView: 1.6,
                centeredSlides: true,
                spaceBetween: 60,
            }
        }
    });

    let sliderAwards = new Swiper('.awards__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.awards-prev',
            nextEl: '.awards-next'
        }
    });

    let sliderAwardsIcons = new Swiper('.awards__slider-icon',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 50,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: '.awards-prev',
            nextEl: '.awards-next'
        },
        breakpoints: {
            640: {
                slidesPerView: 4,
                spaceBetween: 50,
            }
        }
    });

    let sliderHighlights = new Swiper('.highlights__slider',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.highlights-pagination',
            clickable: true
        },
        breakpoints: {
            650: {
                slidesPerView: 2.2,
                spaceBetween: 15,
                pagination: false
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 0
            }
        }
    });

    let sliderGrid = new Swiper('.grid-quad__slider',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.grid-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.grid-prev',
            nextEl: '.grid-next'
        }
    })

});